export default __webpack_public_path__ + "static/sign-up-image-75663d0288fe12ae3acfd1b472e92df6.jpg";